import Header from './components/Header'
import { React, useState, useEffect } from 'react'
import ReactDOM from 'react-dom';
import Countdown, { zeroPad } from 'react-countdown';
import config from './config';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import NumberFormat from 'react-number-format';
firebase.initializeApp(config);

function App() {
  var url_string = window.location.href;
  var url = new URL(url_string);
  const app = url.searchParams.get("app") || 'pharmacy';
  const firstday = false;
  const [product, setProduct] = useState({
    id: 'com.sarutech.' + app + '.standard',
    name: 'Standard License',
    amount: (firstday) ? 75 : 100,
    price: 150,
    edit: false,
    license: true,
    user: "<p>Renew at $80/year</p><p>30 days Refund Policy </p>Suited for standard business run by 2 to 10 users.",
    description: "<ul class=\"table-list\"> <li>All App Features</li> <li><span class=\"unlimited\"> 2 - 10 Devices</span></li> <li>Single Business</li> <li><span class=\"unlimited\">Automatic Backup</span></li> <li><span class=\"unlimited\">Online &amp; Offline</span></li> <li>In-App Customisations</li> <li>No Branding</li> <li>Full Support</li> </ul>",
    discount: (firstday) ? 50 : 33.3,
    discount_name: (firstday) ? 'First Day Promo (50% Off)' : 'Huge Savings',
    discount_end: null,
  })
  const [products, setProducts] = useState([
    {
      id: 'com.sarutech.' + app + '.subsidized',
      name: 'Small Business',
      amount: (firstday) ? 120 : 150,
      price: 200,
      edit: false,
      license: true,
      user: "<p>One Time Fee</p><p>30 days Refund Policy </p>Suited for startup business run by 1 user",
      description: "<ul class=\"table-list\"> <li>All App Features</li> <li>Single Device</li> <li>Single Business</li> <li>Manual Backup</li> <li>Use Offline</li> <li>In-App Customisations</li> <li>No Branding</li> <li>Full Support</li> </ul>",
      discount: (firstday) ? 40 : 25,
      discount_name: (firstday) ? 'First Day Promo (40% Off)' : 'Huge Savings',
      discount_end: null,
    },
    {
      id: 'com.sarutech.' + app + '.standard',
      name: 'Standard License',
      amount: (firstday) ? 75 : 100,
      price: 150,
      edit: false,
      license: true,
      user: "<p>Renew at $80/year</p><p>30 days Refund Policy </p>Suited for standard business run by 2 to 10 users.",
      description: "<ul class=\"table-list\"> <li>All App Features</li> <li><span class=\"unlimited\"> 2 - 10 Devices</span></li> <li>Single Business</li> <li><span class=\"unlimited\">Automatic Backup</span></li> <li><span class=\"unlimited\">Online &amp; Offline</span></li> <li>In-App Customisations</li> <li>No Branding</li> <li>Full Support</li> </ul>",
      discount: (firstday) ? 50 : 33.3,
      discount_name: (firstday) ? 'First Day Promo (50% Off)' : 'Huge Savings',
      discount_end: null,
    },
    {
      id: 'com.sarutech.' + app + '.enterprise',
      name: 'Enterprise',
      amount: (firstday) ? 300 : 400,
      price: 600,
      edit: false,
      license: true,
      user: "<p>Renew at $300/year</p><p>30 days Refund Policy </p>Suited for large business with different branches and with 10+ users.",
      description: "<ul class=\"table-list\"> <li>All App Features</li> <li><span class=\"unlimited\">Unlimited Devices</span></li> <li><span class=\"unlimited\">Multiple Businesses</span></li> <li>Automatic Backup</li> <li>Online &amp; Offline</li> <li><span class=\"unlimited\">Request Customisations</span></li> <li><span class=\"unlimited\">Home Page Branding</span></li> <li>Full Support</li> </ul>",
      discount: (firstday) ? 50 : 33.3,
      discount_name: (firstday) ? 'First Day Promo (50% Off)' : 'Huge Savings',
      discount_end: null,
    }
  ]);

  const [countdownconfig, setCountDown] = useState({
    ['com.sarutech.' + app + '.subsidized']: {
      leftTime: 0,
      template: '$!h!h:$!m!m:$!s-ext!',
    },
    ['com.sarutech.' + app + '.standard']: {
      leftTime: 0,
      template: '$!h!h:$!m!m:$!s-ext!'
    },
    ['com.sarutech.' + app + '.enterprise']: {
      leftTime: 0,
      template: '$!h!h:$!m!m:$!s-ext!'
    }
  })
  var dollar2naira = 400;

  const getDays = (product) => {
    return Math.floor(countdownconfig[product.id].leftTime / 86400)
  }

  /* setCountDown((state, props) => ({
    console.log(state)
  })); */
  const onFinished = (product) => {
    editProduct(product);
    console.log('yes');
  }

  const editProduct = (mproduct) => {
    //the change
    mproduct.amount = mproduct.price;
    //continue
    let index = products.findIndex(product => (product.id == mproduct.id));
    let newProducts = [...products];
    newProducts[index] = mproduct;
    setProducts(newProducts);
    countdownconfig[mproduct.id].leftTime = 0;
    setCountDown(countdownconfig)
  }
  useEffect(() => {
    const fetchProducts = async () => {
      firebase.database().ref('/' + app + '-pricing').once('value').then(function (snapshot) {
        if (snapshot.val() != null) {
          let products = snapshot.val();
          let config = countdownconfig;
          products.map(fproduct => { //refresh current product
            if (firstday) { //first day promo
              fproduct.amount = (0.5 * fproduct.price) - 1;
              fproduct.discount = 50;
              fproduct.discount_name = 'First Day Promo (50% Off)';
            }
            else if (fproduct.discount_end != null && new Date() < new Date(fproduct.discount_end)) { // apply discount if not first day and if not expired
              fproduct.amount = fproduct.price * ((100 - fproduct.discount) / 100);
              config[fproduct.id] = {
                leftTime: Math.max(((new Date(fproduct.discount_end).getTime()) - (new Date().getTime())), 0),
                template: '$!h!h:$!m!m:$!s-ext!'
              }
            }
            if (fproduct.id == product.id) { //set product
              setProduct(fproduct);
            }
          })
          setProducts(products);
          setCountDown(config);
        }
      });
    }
    fetchProducts();
    console.log(app)
  }, []);

  // Random component
  const Completionist = () => <span>Promo has Expired</span>;

  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, milliseconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return <span>{days}D {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}:{milliseconds / 100}</span>;
    }
  };


  return (
    <div className="App">
      <div class="header">
        <h2>Pricing for Perfect {app} Manager</h2>
      </div>
      <div className="pricing-wrapper clearfix">
        {products.map((mproduct) => (
          <div className="pricing-table" onClick={() => setProduct(mproduct)} style={{ border: (product.id == mproduct.id) ? '#f53d3d 3px solid' : 'none' }}>
            <h3 className="pricing-title" style={{ backgroundColor: (product.id == mproduct.id) ? '#f53d3d' : '#057e8b' }}>{mproduct.name}</h3>
            <div className="price">
              {mproduct.price !== mproduct.amount &&
                <span className="slash">${mproduct.price}</span>
              }
              <span className="actual">${mproduct.amount}</span>
            </div>
            {countdownconfig[mproduct.id].leftTime !== 0 &&
              <div className="entity promo margin-top">
                <p style={{ textTransform: 'capitalize' }}>{mproduct.discount_name}</p>
                <span className="countdown">
                  <span>Expires in </span>
                  <Countdown
                    date={Date.now() + countdownconfig[mproduct.id].leftTime}
                    intervalDelay={0}
                    precision={1}
                    renderer={renderer}
                    onComplete={() => onFinished(mproduct)}
                  />
                </span>
              </div>
            }
            <NumberFormat style={{ marginTop: '10px', display: 'block' }}
              value={mproduct.amount * dollar2naira}
              className="foo"
              displayType={'text'}
              thousandSeparator={true}
              prefix={'₦'}
              renderText={(value, props) => <div {...props}>{value}</div>}
            />
            <div className="product" dangerouslySetInnerHTML={{ __html: mproduct.user }}></div>
            <div className="product" dangerouslySetInnerHTML={{ __html: mproduct.description }}></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
